module.exports = __webpack_public_path__ + "img/Tibet Festival 2015.7c3c1a2a.jpg";